import React from "react";
import { FW, StepProgress } from "./ui/primitives";
import { StepScope } from "./ui/steps/step0-scope";
import { StepRol } from "./ui/steps/step1-rol";
import { StepNiveau } from "./ui/steps/step2-niveau";
import { StepTimesheet } from "./ui/steps/step3-timesheet";
import { StepFestivalWerkdagen } from "./ui/steps/step3-festival-werkdagen";
import { StepFestivalDienstverband } from "./ui/steps/step3-festival-dienstverband";
import { StepResult } from "./ui/steps/step4-result";
import { StepFestivalZzpResult } from "./ui/steps/step4-festival-zzp";
import { StepFestivalLoondienstResult } from "./ui/steps/step4-festival-loondienst";

const stepsVoor = (s) => {
  if (s?.type === "festival") {
    if (s?.vorm === "loondienst") {
      return ["Kies type", "Vertel over opdracht", "Schaal", "Dienstverband", "Salaris"];
    }
    return ["Kies type", "Vertel over opdracht", "Schaal", "Werkdagen", "Openingsbod"];
  }
  return ["Kies type", "Vertel over opdracht", "Timesheet", "Zwaarteniveau", "Je bod"];
};

export function App() {
  const urlState = React.useMemo(() => {
    const m = location.hash.match(/#berekening=([^&]+)/);
    if (!m) return null;
    try { return JSON.parse(decodeURIComponent(escape(atob(m[1])))); }
    catch { return null; }
  }, []);

  const [state, setState] = React.useState(() => {
    if (urlState) return urlState;
    try {
      const raw = JSON.parse(localStorage.getItem("fw-calc") || "null");
      if (!raw) return {};
      // v1 -> v2: oude state had platte rol/niveau zonder rollen-array — verse start
      if (!Array.isArray(raw.rollen) && (raw.rol || raw.niveau || raw.draaidagen != null)) return {};
      return raw;
    } catch { return {}; }
  });
  const [step, setStep] = React.useState(() => {
    if (urlState) return 4;
    try {
      const raw = JSON.parse(localStorage.getItem("fw-step") || "0");
      return Number.isInteger(raw) && raw >= 0 && raw <= 4 ? raw : 0;
    } catch { return 0; }
  });

  React.useEffect(() => { localStorage.setItem("fw-calc", JSON.stringify(state)); }, [state]);
  React.useEffect(() => { localStorage.setItem("fw-step", JSON.stringify(step)); }, [step]);
  React.useEffect(() => { window.scrollTo({ top: 0, behavior: "smooth" }); }, [step]);

  const STEPS = stepsVoor(state);
  const next    = () => setStep((s) => Math.min(STEPS.length - 1, s + 1));
  const back    = () => setStep((s) => Math.max(0, s - 1));
  const restart = () => { setState({}); setStep(0); location.hash = ""; };

  const isFestival = state.type === "festival";
  const isLoondienst = isFestival && state.vorm === "loondienst";

  return (
    <div>
      <TopBar />
      {step > 0 && (
        <div className="progress-bar">
          <div className="progress-bar-inner" style={{ display: "flex", justifyContent: "center" }}>
            <StepProgress steps={STEPS} current={step} onJumpTo={setStep} />
          </div>
        </div>
      )}

      <div className="app-shell">
        {step === 0 && <StepScope  state={state} setState={setState} next={next} />}
        {step === 1 && <StepRol    state={state} setState={setState} next={next} back={back} />}
        {step === 2 && (
          isFestival
            ? <StepNiveau    state={state} setState={setState} next={next} back={back} />
            : <StepTimesheet state={state} setState={setState} next={next} back={back} />
        )}
        {step === 3 && (
          isFestival
            ? (isLoondienst
                ? <StepFestivalDienstverband state={state} setState={setState} next={next} back={back} />
                : <StepFestivalWerkdagen     state={state} setState={setState} next={next} back={back} />)
            : <StepNiveau state={state} setState={setState} next={next} back={back} />
        )}
        {step === 4 && (
          isFestival
            ? (isLoondienst
                ? <StepFestivalLoondienstResult state={state} setState={setState} back={back} restart={restart} />
                : <StepFestivalZzpResult        state={state} setState={setState} back={back} restart={restart} />)
            : <StepResult state={state} setState={setState} back={back} restart={restart} />
        )}
      </div>
    </div>
  );
}

const TopBar = () => (
  <div className="top-bar" style={{
    padding: "20px 40px 0", display: "flex", justifyContent: "space-between", alignItems: "center",
    gap: 12, maxWidth: 1240, margin: "0 auto",
  }}>
    <div style={{ display: "inline-flex", alignItems: "center", gap: 10, minWidth: 0 }}>
      <img src="/assets/logo-filmwerkwijs.svg" alt="Filmwerkwijs" className="top-bar-logo" style={{ height: "64px", width: "auto" }} />
    </div>
    <div className="top-bar-tagline" style={{ display: "inline-flex", alignItems: "center", gap: 8, fontSize: 14, color: FW.navy2 }}>
      <i className="ri-shield-check-line" />
      <span>Fair Pay richtlijn 2026</span>
    </div>
  </div>
);
